<!-- Loading bar -->
<fuse-loading-bar></fuse-loading-bar>
<!-- Este es el que se usa -->
<!-- Navigation -->
@if (navigation && navigation.default) {
  
  <fuse-vertical-navigation
      class="dark bg-gray-900 print:hidden"
      [mode]="isScreenSmall ? 'over' : 'side'"
      [name]="'mainNavigation'"
      [navigation]="navigation.default"
      [opened]="!isScreenSmall">
      <!-- Navigation header hook -->
      <ng-container fuseVerticalNavigationContentHeader>
          <div class="flex items-center w-full p-4 pl-6">
              <!-- Components -->
              <div class="flex items-center ml-auto">
                  <user [showAvatar]="false"></user>
              </div>
          </div>
          <!-- User -->
          <div class="flex flex-col items-center w-full">
              <div class="relative w-full flex flex-col items-center justify-end">
                <img
                  class="w-full"
                  src="assets/images/logo/logo_b_sin_subtitulo.png">
              </div>
              <div class="flex flex-col items-center justify-center w-full mt-6">
                  <div class="w-full whitespace-nowrap text-ellipsis overflow-hidden text-center leading-normal font-medium">
                      {{user.name}}
                  </div>
                  <div class="w-full mt-0.5 whitespace-nowrap text-ellipsis overflow-hidden text-center text-md leading-normal font-medium text-secondary">
                      {{user.email}}
                  </div>
              </div>
          </div>
          <mat-form-field appearance="outline" class="mt-4 w-full px-4">
            <mat-label>Catlálogo de la sucursal</mat-label>
            <mat-select [value]="sucursalSeleccionada()" (selectionChange)="cambiarSucursal($event.value)">
              @for (sucursal of sucursales(); track sucursal.id) {
                <mat-option [value]="sucursal.id">
                  {{sucursal.nombre}}
                </mat-option>
              }
            </mat-select>
            @if (sinSucursales()) {
              <mat-hint class="text-red-600">No hay sucursales activas asignadas</mat-hint>
            }
          </mat-form-field>
      </ng-container>
      <!-- Navigation footer hook -->
      <ng-container fuseVerticalNavigationContentFooter>
          <div class="block h-16 pr-6 pl-2 mt-2 mb-4 opacity-12">
          </div>
      </ng-container>
  </fuse-vertical-navigation>
}

<!-- Wrapper -->
<div class="flex flex-col flex-auto w-full min-w-0">

    <!-- Header -->
    <div class="relative flex flex-0 items-center w-full h-16 px-4 md:px-6 z-49 shadow dark:shadow-none dark:border-b bg-card dark:bg-transparent print:hidden">
        <!-- Navigation toggle button -->
        <button
            mat-icon-button
            (click)="toggleNavigation('mainNavigation')">
            <mat-icon [svgIcon]="'heroicons_outline:bars-3'"></mat-icon>
        </button>
        <!-- Components -->
        <div class="flex items-center pl-2 ml-auto space-x-0.5 sm:space-x-2">
            <fuse-fullscreen class="hidden md:block"></fuse-fullscreen>
        </div>
    </div>

    <!-- Content -->
    <div class="flex flex-col flex-auto">
        <!-- *ngIf="true" hack is required here for router-outlet to work correctly.
             Otherwise, layout changes won't be registered and the view won't be updated! -->
        <router-outlet *ngIf="true"></router-outlet>
    </div>

    <!-- Footer -->
    <!--<div class="relative flex flex-0 items-center justify-start w-full h-14 px-4 md:px-6 z-49 border-t bg-card dark:bg-transparent print:hidden">
        <span class="font-medium text-secondary">Fuse &copy; {{currentYear}}</span>
    </div>-->

</div>

<!-- Quick chat -->
